module.exports = __webpack_public_path__ + "img/1.46313b2b.svg";